﻿import React, { useContext, useEffect, useState } from 'react';

import { BookingFlowContext } from '../BookingFlowContext'
import { facility } from '../Endpoints'
import { htmlPromise } from '../../../../../Resources/Scripts/_Shared/fetch';

import { Heading } from '../partials/Heading'
import { HtmlOutput } from '../../../../../Resources/Scripts/_Shared/elements/HtmlOutput'

const OrderConfirmation = () => {
  const { bookingFlowContext } = useContext(BookingFlowContext);
  const [offersHtml, setOffersHtml] = useState(null);
  const typeformId = '01HV4161P35AKJXR3CK4FE76AB';
  const currentCountry = document.querySelector('html').getAttribute('country');

  useEffect(() => {
    setTimeout(() => {
      var n = sessionStorage.length;
      while(n--) {
        var key = sessionStorage.key(n);
        if(/__aimo-booking-flow__/.test(key)) {
          sessionStorage.removeItem(key);
        }
      }
    }, 1000);
    getOffers();
  }, [])

  useEffect(() => {
    if (currentCountry !== 'se') return;
    //Add external typeform script tag
    const tagAlreadyExists = !!document.querySelector('script[data-typeform-embed]');
    if (tagAlreadyExists) return;
    const tag = document.createElement('script');
    tag.setAttribute('data-typeform-embed', true);
    tag.setAttribute('src', 'https://embed.typeform.com/next/embed.js');
    document.body.appendChild(tag);
    return () => document.body.removeChild(tag);
  }, []);

  const getOffers = async () => {
    const epslanguage = bookingFlowContext.localization.language;
    const fId = bookingFlowContext.facility.id;
    const offers = await facility.getConfirmationPageOffers({ fId, epslanguage });
    if (offers.status === 200) setOffersHtml(offers.body);
  }

  return (
    <div className="bookingflowpage__app bookingflowpage__app--confirmation">
      <div className="single-step single-step--confirmation">
        <Heading text={bookingFlowContext.localization.orderConfirmation.heading} />
        <p><HtmlOutput html={bookingFlowContext.localization.orderConfirmation.text.replace('{0}', bookingFlowContext.availableSteps.orderOverview.formData.Uid)} /></p>
        <a href={bookingFlowContext.episerver.completionLink}>{bookingFlowContext.localization.orderConfirmation.link}</a>
      </div>
      {/*Typeform container*/}
      <div style={{minHeight:'340px'}} data-tf-live={typeformId}></div>
      {offersHtml && <div className="facilitypage__offers" dangerouslySetInnerHTML={{ __html: offersHtml }}></div>}
    </div>
  )
}

export default OrderConfirmation;
